<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { RouterLink } from 'vue-router'

import AppHeader from '@/components/layout/AppHeader.vue'

/** Shell for public pages: header and footer, no sidebar. */
const { t } = useI18n()
const year = new Date().getFullYear()
</script>

<template>
  <div class="flex min-h-dvh flex-col">
    <a href="#main-content" class="sr-only-focusable btn-gold absolute top-2 left-2 z-100">
      {{ t('common.skipToContent') }}
    </a>

    <AppHeader />

    <main id="main-content" class="flex-1">
      <slot />
    </main>

    <footer class="chrome-surface border-t border-black/30 px-4 py-6">
      <p class="text-parchment-300 text-center text-xs">
        © {{ year }} {{ t('brand.name') }} — {{ t('brand.tagline') }}
      </p>
      <p class="mt-2 text-center text-xs">
        <RouterLink
          :to="{ name: 'privacy-policy' }"
          class="text-parchment-200 inline-flex min-h-10 items-center hover:text-white hover:underline"
        >
          {{ t('privacy.link') }}
        </RouterLink>
      </p>
    </footer>
  </div>
</template>
